/**
 * Object tool — create rectangle, point, and polygon objects on object layers.
 */
export class ObjectTool {
  constructor(state) {
    this.state = state;
    this.mode = 'rectangle'; // 'rectangle' | 'point' | 'polygon'
    this._startX = 0;
    this._startY = 0;
    this._active = false;
    this._nextObjectId = 1;
  }

  setMode(mode) {
    this.mode = mode;
  }

  onDown(tx, ty) {
    const layer = this.state.getActiveLayer();
    if (!layer || layer.type !== 'objectgroup') return;

    const tileW = this.state.get('tileWidth');
    const tileH = this.state.get('tileHeight');

    if (this.mode === 'point') {
      if (!layer.objects) layer.objects = [];
      layer.objects.push({
        id: this._nextObjectId++,
        name: '',
        type: '',
        x: tx * tileW,
        y: ty * tileH,
        width: 0,
        height: 0,
        point: true,
        visible: true,
        properties: {},
      });
      this.state.set('dirty', true);
      this.state._notify('layers', this.state.get('layers'), this.state.get('layers'));
      return;
    }

    this._startX = tx;
    this._startY = ty;
    this._active = true;
    this.state.set('selectionStart', { x: tx, y: ty });
    this.state.set('selectionEnd', { x: tx, y: ty });
  }

  onMove(tx, ty) {
    if (!this._active) return;
    this.state.set('selectionEnd', { x: tx, y: ty });
  }

  onUp(tx, ty) {
    if (!this._active) return;
    this._active = false;

    const layer = this.state.getActiveLayer();
    if (!layer || layer.type !== 'objectgroup') return;

    const tileW = this.state.get('tileWidth');
    const tileH = this.state.get('tileHeight');

    const x1 = Math.min(this._startX, tx);
    const y1 = Math.min(this._startY, ty);
    const x2 = Math.max(this._startX, tx);
    const y2 = Math.max(this._startY, ty);

    if (!layer.objects) layer.objects = [];
    layer.objects.push({
      id: this._nextObjectId++,
      name: '',
      type: '',
      x: x1 * tileW,
      y: y1 * tileH,
      width: (x2 - x1 + 1) * tileW,
      height: (y2 - y1 + 1) * tileH,
      visible: true,
      properties: {},
    });

    this.state.set('dirty', true);
    this.state.set('selectionStart', null);
    this.state.set('selectionEnd', null);
    this.state._notify('layers', this.state.get('layers'), this.state.get('layers'));
  }
}
